function Cache(maxSize) {
  // 存储数据的对象
  this.data = {};
  // 最大存储个数，默认为10
  this.maxSize = maxSize || 10;
  // 存储顺序队列，记录存储的key和时间
  this.queue = [];

  // 通过 key 获取 value
  this.get = function (key) {
    const record = this.data[key];
    if (!record) {
      return null;
    }

    // 判断是否过期，过期的数据将被删除
    if (record.expirationTime && record.expirationTime < Date.now()) {
      this.delete(key);
      return null;
    }

    return record.value;
  };

  // 通过 key 设置 value，可以设置有效期
  this.set = function (key, value, expirationTime) {
    // 如果key已存在，先从队列中删除
    const existingIndex = this.queue.findIndex(function (item) {
      return item.key === key;
    });
    if (existingIndex !== -1) {
      this.queue.splice(existingIndex, 1);
    }

    // 检查是否超过最大存储个数
    if (this.queue.length >= this.maxSize) {
      // 删除最早存储的数据
      const oldest = this.queue.shift();
      if (oldest) {
        delete this.data[oldest.key];
      }
    }

    // 添加新数据
    this.data[key] = {
      value: value,
      expirationTime: expirationTime ? Date.now() + expirationTime : null, // 计算过期时间
      createTime: Date.now() // 记录创建时间
    };

    // 将key添加到队列末尾
    this.queue.push({
      key: key,
      time: Date.now()
    });
  };

  // 从 Cache 中删除一组数据
  this.delete = function (key) {
    delete this.data[key];
    // 从队列中删除
    const index = this.queue.findIndex(function (item) {
      return item.key === key;
    });
    if (index !== -1) {
      this.queue.splice(index, 1);
    }
  };

  // 清空 Cache 中的所有数据
  this.clear = function () {
    this.data = {};
    this.queue = [];
  };

  // 获取当前缓存数量
  this.size = function () {
    return this.queue.length;
  };
}

let cache = new Cache();

module.exports = { cache, Cache };
